import { render, staticRenderFns } from "./Develop.vue?vue&type=template&id=7855b5ad&scoped=true&"
import script from "./Develop.vue?vue&type=script&lang=js&"
export * from "./Develop.vue?vue&type=script&lang=js&"
import style0 from "../../layout.css?vue&type=style&index=0&id=7855b5ad&scoped=true&lang=css&"
import style1 from "./Develop.vue?vue&type=style&index=1&id=7855b5ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7855b5ad",
  null
  
)

export default component.exports